import { render } from "./Edit.vue?vue&type=template&id=13001b96"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=13001b96&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/ProductVariants/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "13001b96"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('13001b96', __exports__)) {
    api.reload('13001b96', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=13001b96", () => {
    api.rerender('13001b96', render)
  })

}


export default __exports__